import React from 'react'
import { ExclamationCircleIcon, ArrowPathIcon } from '@heroicons/react/24/outline'

const ErrorMessage = ({ message, onRetry, className = '' }) => {
  return (
    <div className={`alert-danger ${className}`}>
      <ExclamationCircleIcon className="alert-icon text-red-500" aria-hidden="true" />
      <div className="flex-1">
        <h3 className="text-sm font-semibold text-red-800 dark:text-red-200">
          Something went wrong
        </h3>
        <p className="mt-1 text-sm text-red-700 dark:text-red-300">
          {message}
        </p>
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="mt-3 inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5
              text-sm font-medium
              text-red-700 bg-red-100 border border-red-200
              hover:bg-red-200 hover:border-red-300
              dark:text-red-200 dark:bg-red-50 dark:border-red-200
              dark:hover:bg-red-100
              transition-colors duration-150
              focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500"
          >
            <ArrowPathIcon className="h-4 w-4" />
            Try again
          </button>
        )}
      </div>
    </div>
  )
}

export default ErrorMessage 